import React, { memo } from 'react';

const DefaultWhenNullFormatter = props => {
  const value = props.value;

  const { dependentValues } = props;
  if (dependentValues && dependentValues.options) {
    const { options } = dependentValues;

    if (options.defaultValue && !props.value) {
      return options.defaultValue;
    }
  }

  return value;
};

export default memo(DefaultWhenNullFormatter, (prevProps, nextProps) => nextProps === prevProps.value);
